import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  benchData: "",
  benchInfo: {},
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setBenchData: (state, action) => {
      state.benchData = action.payload;
    },
    setBenchInfo: (state, action) => {
      state.benchInfo = action.payload;
    },
    resetBenchData: (state) => {
      state.benchData = "";
    },
  },
});

export const { setBenchData, resetBenchData, benchInfo } = homeSlice.actions;
export default homeSlice.reducer;
